export default __webpack_public_path__ + "static/media/share-tw-hover.ccc900da.svg";